/**
 * Removes any properties from the given object that are `undefined`
 *
 * __NOTE:__ this is done in-place
 *
 * @example
 *
 * const foo = { a: 1, b: undefined }
 * console.log(Object.hasOwn(foo, 'b')) // true
 *
 * removeUndefinedProperties(foo)
 * console.log(Object.hasOwn(foo, 'b')) // false
 */
export function removeUndefinedProperties<T>(obj: T): T {
  if (obj) {
    for (const k in obj) {
      if (obj[k] === undefined) {
        delete obj[k]
      }
    }
  }
  return obj
}
